/* eslint-disable react/jsx-no-useless-fragment */
import { Slider, Tooltip } from "@mui/material";
import { SliderValueLabelProps } from "@mui/material/Slider/SliderValueLabel.types";
import React, { memo } from "react";
import { useMediaQuery } from "react-responsive";

function ValueLabelComponent(props: SliderValueLabelProps) {
  const { children = <></>, value } = props;
  const isMobile = useMediaQuery({ maxWidth: 700 });
  return (
    <Tooltip
      enterTouchDelay={0}
      placement={isMobile ? "top" : "bottom"}
      title={value}
      classes={{
        tooltip: "md:!bg-transparent !bg-white !text-black !text-xs !font-montserrat !font-semibold"
      }}
    >
      {children}
    </Tooltip>
  );
}

interface Props {
  heading: string;
  formik: any;
  name: string;
  valueLabelFormat: string | ((value: number, index: number) => React.ReactNode);
  range: Record<string, number>;
  steps?: number;
  marks?: boolean;
}
function CustomSlider({
  heading,
  name,
  formik: { value, setFieldValue },
  valueLabelFormat,
  range,
  steps,
  marks
}: Props) {
  const handleChange = (_: any, newValue: number | number[]) =>
    setFieldValue(name, newValue as number[]);
  return (
    <div className="space-y-3">
      <div className="font-semibold text-sm">{heading}</div>
      <div>
        <Slider
          value={value}
          onChange={handleChange}
          valueLabelDisplay="on"
          valueLabelFormat={valueLabelFormat}
          min={range.min}
          max={range.max}
          step={steps}
          marks={marks}
          slots={{
            valueLabel: ValueLabelComponent
          }}
        />
      </div>
    </div>
  );
}

CustomSlider.defaultProps = {
  steps: 1,
  marks: false
};

export default memo(CustomSlider);
